<template>
  <div
    class="the-settings-points-categories"
    v-loading="loading"
  >
    <h3>Настройка категорий акций</h3>
    <p>Внизу приведен список категорий, которые могут присваиваться акциям.</p>
    <div class="the-settings-points-categories__list">
      <el-tag
        :key="tag"
        v-for="tag in categories"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)"
        class="the-settings-points-categories__item"
        size="small"
      >
        {{tag}}
      </el-tag>
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="mini"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      >
      </el-input>
      <el-button v-else class="button-new-tag" size="mini" @click="showInput">+ Категорию</el-button>
    </div>
  </div>
</template>

<script>
/**
 * Component: the-settings-points-categories - Компонент настройки категорий акций
 *
 * @version 1.0.0
 */

import { mapGetters, mapActions } from 'vuex';


export default {
  name: 'the-settings-points-categories',

  data() {
    return {
      categories: [],
      inputVisible: false,
      inputValue: '',
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      pointsCategories: 'settings/pointsCategories',
    }),
  },

  watch: {
    pointsCategories: {
      handler: function() {
        this.categories = this.pointsCategories;
      },
      deep: true,
    },
  },

  async created() {
    await this.getAppSettings();
    this.categories = this.pointsCategories;
  },

  methods: {
    async update(categories) {
      console.debug('update');
      const { error } = await this.setPointsCategories(categories);
      if (error) {
        this.$notify({
          title: 'Update Points Categories Error',
          message: error.message,
          duration: 0,
        });
      } else {
        this.getAppSettings();
      }
    },

    async handleClose(tag) {
      this.loading = true;
      console.debug('handleClose');
      const categories = [...this.categories];
      categories.splice(this.categories.indexOf(tag), 1);
      await this.update(categories);
      this.loading = false;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    async handleInputConfirm() {
      this.loading = true;
      console.debug('handleInputConfirm');
      const categories = [...this.categories];
      let inputValue = this.inputValue;
      if (inputValue) {
        categories.push(inputValue);
      }
      await this.update(categories);
      this.inputVisible = false;
      this.inputValue = '';
      this.loading = false;
    },

    ...mapActions({
      setPointsCategories: 'settings/setPointsCategories',
      getAppSettings: 'settings/getAppSettings',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-settings-points-categories {
  $this: &;

  &__list {
    margin-bottom: 2 * $vp;
  }

  &__item {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .button-new-tag {
    height: 24px;
    line-height: 22px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    vertical-align: bottom;
    height: 24px;
  }
}
</style>
